import useBreakpoint from '@/hooks/useBreakpoint';

const useIsMobile = () => {
  const breakpoints = useBreakpoint();

  return breakpoints && breakpoints === 'xs';
};

export default useIsMobile;
